<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import CIcon from '@lib/components/CIcon/CIcon.vue'
import CButton from '@lib/components/CButton/CButton.vue'
import tooltipDirective from '@lib/directives/tooltip'
import type { ViewCompactFileFolder } from '@lib/types/files'
import useAppStore from '@browser/stores/app'
import useThemeVars from '@lib/composables/useThemeVars'

const { selectAndOpenContentPanel } = useAppStore()
const themeVars = useThemeVars()
const { t } = useI18n()
const vTooltip = tooltipDirective

defineProps<{ item: ViewCompactFileFolder }>()
</script>
<template>
  <CButton
    v-tooltip="t('canvasUI.browserApp.foldersFilesTable.openFileDetailsPanel')"
    circle
    class="h-9 w-9"
    :color="themeVars.primary"
    secondary
    type="default"
    @click.stop="selectAndOpenContentPanel(item as ViewCompactFileFolder)"
  >
    <template #icon>
      <CIcon icon="info-circle" size="12px" />
    </template>
  </CButton>
</template>
